// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { TopBarSiteWideMessageFragmentDoc } from './TopBarSiteWideMessage.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../../cms/index.generated';
import { TopBarConsultationPromptFragmentDoc } from './TopBarConsultationPrompt.fragment.generated';
export const TopBarFragmentDoc = `
    fragment topBar on TopBar {
  __typename
  siteWideMessage {
    ...topBarSiteWideMessage
  }
  consultationPrompt {
    ...topBarConsultationPrompt
  }
}
    `;